import React from 'react'
import * as Yup from 'yup'
import styles from 'components/Shared/CrudComponents/SimpleForm.module.css'
import { useTranslation } from 'react-i18next'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { UserAccountFormFields } from 'components/Users/UserAccountFormFields'
import { DatePickerFormFieldInline } from 'components/Shared/DatePickerInline'
import driverFormStyles from 'components/Drivers/DriverForm/DriverForm.module.css'
import { Form, useFormikContext } from 'formik'
import { ContractorSelectField } from 'components/Carrier/CarrierSelectField'
import { FormColumn, FormRow } from 'components/Shared/CrudComponents'
import Sections from 'components/Drivers/sections'
import { FilesDropzone } from 'components/Shared/FilesDropzone'
import { uploadFile } from 'services/DriverService'
import {
  useAuth,
  DRIVER_ACCOUNT_WRITE,
  DRIVER_ADDITIONAL_DATA_WRITE,
  DRIVER_ATTACHMENTS_WRITE,
  DRIVER_CARRIER_WRITE,
  DRIVER_DATA_WRITE,
  DRIVER_CARRIER_READ,
  DRIVER_DATA_READ,
  DRIVER_ADDITIONAL_DATA_READ,
  DRIVER_ATTACHMENTS_READ,
  DRIVER_ACCOUNT_READ
} from 'context/auth'

export const driverSchema = Yup.object().shape({
  firstName: Yup.string().required('form.validation.required'),
  lastName: Yup.string().required('form.validation.required'),
  address: Yup.string().required('form.validation.required'),
  phoneNumber: Yup.string().required('form.validation.required'),
  personalPhoneNumber: Yup.string().required('form.validation.required'),
  idCardNumber: Yup.string().required('form.validation.required'),
  idCardExpirationDate: Yup.string().nullable().required('form.validation.required'),
  driverLicenseNumber: Yup.string().required('form.validation.required'),
  driverLicenseCategory: Yup.string().required('form.validation.required'),
  driverLicenseExpirationDate: Yup.string().nullable().required('form.validation.required'),
  adrCertificateNumber: Yup.string().nullable(),
  adrCertificateExpirationDate: Yup.string().nullable(),
  carrierId: Yup.string().required('form.validation.required').nullable(),
  filesIds: Yup.array()
})

export function DriverForm ({ createForm = false, initialFiles }) {
  const { setFieldValue } = useFormikContext()
  const { t } = useTranslation()
  const { hasAnyPrivileges } = useAuth()

  return <Form>
    <FormRow>
      <FormColumn section={Sections.Carrier}
                  disabled={!hasAnyPrivileges([DRIVER_CARRIER_WRITE])}
      visible={hasAnyPrivileges([DRIVER_CARRIER_READ])}>
        <ContractorSelectField
          label={'form.driver.carrier'}
          fieldName="carrierId"
          className={driverFormStyles.select}
          role='CARRIER'
        />
      </FormColumn>
      <FormColumn section={Sections.BasicDetails}
                  disabled={!hasAnyPrivileges([DRIVER_DATA_WRITE])}
                  visible={hasAnyPrivileges([DRIVER_DATA_READ])}>
        <FieldComponent fieldName={'firstName'}
                        label={'form.driver.firstName'}/>
        <FieldComponent fieldName={'lastName'}
                        label={'form.driver.lastName'}/>
        <FieldComponent fieldName={'personalPhoneNumber'}
                        label={'form.driver.personalPhoneNumber'}/>
        <FieldComponent fieldName={'phoneNumber'}
                        label={'form.driver.phoneNumber'}/>
        <FieldComponent fieldName={'address'}
                        label={'form.driver.address'}/>
        <FieldComponent fieldName={'idCardNumber'}
                        label={'form.driver.idCardNumber'}/>
        <DatePickerFormFieldInline
          label={'form.driver.idCardExpirationDate'}
          name={'idCardExpirationDate'}
        />
      </FormColumn>
      <FormColumn section={Sections.AdditionalDetails}
                  disabled={!hasAnyPrivileges([DRIVER_ADDITIONAL_DATA_WRITE])}
                  visible={hasAnyPrivileges([DRIVER_ADDITIONAL_DATA_READ])}>
        <FieldComponent fieldName={'adrCertificateNumber'}
                        label={'form.driver.adrCertificateNumber'}/>
        <DatePickerFormFieldInline
          label={'form.driver.adrCertificateExpirationDate'}
          name={'adrCertificateExpirationDate'}
        />
        <FieldComponent fieldName={'driverLicenseNumber'}
                        label={'form.driver.driverLicenseNumber'}/>
        <FieldComponent fieldName={'driverLicenseCategory'}
                        label={'form.driver.driverLicenseCategory'}/>
        <DatePickerFormFieldInline
          label={'form.driver.driverLicenseExpirationDate'}
          name={'driverLicenseExpirationDate'}
        />
      </FormColumn>
      <FormColumn section={Sections.Files}
                  className={driverFormStyles.dropzoneSection}
                  disabled={!hasAnyPrivileges([DRIVER_ATTACHMENTS_WRITE])}
                  visible={hasAnyPrivileges([DRIVER_ATTACHMENTS_READ])}>
        <FilesDropzone initialFiles={initialFiles} onUpload={uploadFile}
                       onFilesUpdated={(updatedFiles) => setFieldValue('filesIds', updatedFiles.map(file => file.id))}/>
      </FormColumn>
      {createForm && <div className={styles.container}>
        <h2>{t('form.driver.credentials')}</h2>
        <UserAccountFormFields disabled={!hasAnyPrivileges([DRIVER_ACCOUNT_WRITE])}
                               visible={hasAnyPrivileges([DRIVER_ACCOUNT_READ])}/>
      </div>}
    </FormRow>
  </Form>
}
